import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ForcePinChange from "./ForcePinChange";

const ProtectedRoute = ({ children }) => {
  const { user, loading, setUser } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => { 
    if (!loading && !user) navigate("/"); 
  }, [user, loading, navigate]);
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-primary"></div>
      </div>
    );
  }
  
  // Check if user needs to update PIN (non-admin users only)
  if (user && !user.is_admin && !user.pin_updated) {
    return (
      <ForcePinChange 
        user={user} 
        onPinUpdated={(updatedUser) => {
          setUser(updatedUser);
          localStorage.setItem("ltg_user", JSON.stringify(updatedUser));
        }} 
      />
    );
  }
  
  return user ? children : null;
};

export default ProtectedRoute;
